/**
 * Profile Statistics Service
 * API service for fetching user profile statistics
 */

import { apiClient } from "@/lib/api-client"
import type { ProfileStatisticsResponse } from "../types/profile.types"

/**
 * Get user profile statistics
 * @param userId - The user ID to fetch statistics for
 * @returns Profile statistics response with teachings, practicing, and communities counts
 */
export const getProfileStatistics = async (userId: string): Promise<ProfileStatisticsResponse> => {
  const response = await apiClient.get(`/api/profiles/${userId}/statistics`)
  return response.data
}
